import { beachLocation } from './locations/registry';
import { isFeatureFlagEnabled } from "@/lib/feature-flags";

export type BeachSelection = { date: string; hour: number };
export function beachExplorerEnabled(slug: string, value = process.env.NEXT_PUBLIC_FF_BEACH_EXPLORER): boolean {
  return !!beachLocation(slug) && beachLocation(slug)!.rollout !== 'disabled' && isFeatureFlagEnabled('beachExplorer', { NEXT_PUBLIC_FF_BEACH_EXPLORER: value });
}
export function readBeachSelection(date: string | null, hour: string | null, today: string, defaultHour: number): BeachSelection {
  const ms = date && /^\d{4}-\d{2}-\d{2}$/.test(date) ? Date.parse(`${date}T00:00:00Z`) : NaN;
  const validDate = Number.isFinite(ms) && new Date(ms).toISOString().slice(0, 10) === date;
  const h = hour !== null && /^\d{1,2}$/.test(hour) ? Number(hour) : NaN;
  return { date: validDate ? date! : today, hour: Number.isInteger(h) && h >= 0 && h <= 23 ? h : defaultHour };
}
export function beachActivitySport(sport: string): string {
  return ({ surf: 'surfing', swim: 'swimming', bodyboarding: 'bodyboarding', 'sailing-club': 'sailing' } as Record<string, string>)[sport] ?? 'off';
}
